export const ApckDropdown = {
    props: {
      isOpen: {
        type: Boolean,
        default: false,
      },
      value: {
        type: String,
        default: '',
      },
      btnClass: {
        type: String,
        default: 'btn-primary'
      },
      icon: {
        type: String,
        default: 'fa-caret-down'
      },
      menuPosition: {
        type: String,
        default: 'left',
      },
    },
    data() {
      return {
        isDropdownOpen: this.isOpen,
      };
    },
    computed: {
      menuClass() {
        if (this.menuPosition === 'right') return 'dropdown__menu--right';
      }
    },
    watch: {
      isOpen(newValue) {
        this.isDropdownOpen = newValue;
      }
    },
    mounted () {
        document.addEventListener('click', this.clickOutside);
    },
    created() {

    },
    destroyed() {
      document.removeEventListener('click', this.clickOutside);
    },
    methods: {
      toggle() {
        this.isDropdownOpen = !this.isDropdownOpen;
        this.$emit('update:isOpen', this.isDropdownOpen);
      },
      closeDropDown() {
        this.isDropdownOpen = false;
        this.$emit('update:isOpen', this.isDropdownOpen);
      },
      clickOutside(event) {
        if (!(this.$el === event.target || this.$el.contains(event.target))) {
          this.closeDropDown();
        }
      }
    },
    template: `
      <div class="dropdown">
        <apck-button
          :title="value"
          :value="value"
          :class="btnClass"
          :icon="icon"
          :right="true"
          @click.stop="toggle"
        />
        <div v-if="isDropdownOpen" :class="['dropdown__menu', menuClass]">
          <slot></slot>
        </div>
      </div>`,
};
